<div class="padding-b-70 wow fadeIn"
     data-wow-duration="500ms">
   <div class="pageBanner leadership"></div>
   <div class="">
      <div class="">
         <div class="pageTabs flex hr-center sapientsansmedium font-15">
            <a routerLink="/team/saurabh-mittal" [ngClass]="{'active': path?.currentRout('team/saurabh-mittal')}" class="wow fadeInUp"
               data-wow-duration="500ms" data-wow-delay="100ms">Saurabh Mittal</a>
            <a routerLink="/team/leadership" [ngClass]="{'active': path?.currentRout('team/leadership')}" class="wow fadeInUp"
               data-wow-duration="500ms" data-wow-delay="300ms">Leadership</a>
            <a routerLink="/team/investment" [ngClass]="{'active': path?.currentRout('team/investment')}" class="wow fadeInUp"
               data-wow-duration="500ms" data-wow-delay="300ms">Investment Team</a>
         </div>
      </div>
   </div>

   <router-outlet></router-outlet>

</div>
